import request from '@/utils/request'

/**
 * 获取菜单组目录列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listMenuGroupCatalog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroupCatalog.listMenuGroupCatalog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取菜单组列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listMenuGroups(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroup.listMenuGroups',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存菜单组目录
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function saveMenuGroupCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroupCatalog.saveMenuGroupCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除菜单组目录
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function deleteMenuGroupCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroupCatalog.deleteMenuGroupCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}